
define('known/models/leagueInstanceModel',[
	'jquery',
	'underscore',
	'backbone',
	'known/models/leagueUserModel',
	'known/models/fantasyTeamModel',
	'known/models/leaguePositionModel',
	'known/collections/fantasyTeamCollection',
	'known/collections/leagueUserCollection',
	'known/collections/leaguePositionCollection',
	
	//Shims 
	'backbone.relational'
], function($, _, Backbone, LeagueUserModel, FantasyTeamModel, LeaguePositionModel, FantasyTeamCollection, LeagueUserCollection, LeaguePositionCollection){
	var LeagueInstance = Backbone.RelationalModel.extend({
		defaults: {
			id: null,
			purchaseId: null,
			prodId: null,
			prodLeagueName: null,
			prodType: null,
			timerExpType: null,
			year: null,
			leagueId: null,
			leagueName: null,
			password: null,
			displayName: null,
			playerListId: null,
			draftStatus: null,
			draftType: null,
			numRounds: null,
			numTeams: null,
			timerDuration: null,
			bidDuration: null,
			statsEnabled: null,
			resetDuration: null,
			backgroundColor: null,
			textColor: null,
			timerEnabled: null,
			ranksEnabled: null,
			undoEnabled: null,
			rookieEnabled: null,
			vetEnabled: null,
			conf1Enabled: null,
			conf2Enabled: null,
			timerDisableTime: null,
			timerEnableTime: null,
			timerTZ: null,
			draftTimer: null,
			statScores: null,
	    },
	    
	    relations: [{
	        type: Backbone.HasMany,
	        key: 'leagueUsers',
	        relatedModel: LeagueUserModel,
	        collectionType: LeagueUserCollection,
	        collectionOptions: function(model) {
	            return {
	            	leagueId: model.get('leagueId')//,
	            	//leagueInstanceId: model.get('id')
	            };
	        },
	        reverseRelation: {
	            key: 'leagueInstanceId',
	            includeInJSON: 'id'
	        }
	    },{
	        type: Backbone.HasMany,
	        key: 'fantasyTeams',
	        relatedModel: FantasyTeamModel,
	        collectionType: FantasyTeamCollection,
	        collectionOptions: function(model) {
	            return {
	            	leagueId: model.get('leagueId')//,
	            	//leagueInstanceId: model.get('id')
	            };
	        },
	        reverseRelation: {
	            key: 'leagueInstanceId',
	            includeInJSON: false
	        }
	    },{
	        type: Backbone.HasMany,
	        key: 'leaguePositions',
	        relatedModel: LeaguePositionModel,
	        collectionType: LeaguePositionCollection,
	        collectionOptions: function(model) {
	            return {
	            	leagueId: model.get('leagueId'),
	            	prodLgName: model.get('prodLeagueName')
	            	//leagueInstanceId: model.get('id')
	            };
	        },
	        reverseRelation: {
	            key: 'leagueInstanceId',
	            includeInJSON: false
	        }
	    }],
	    
	    urlRoot: function() {
			return '/draftapp/leagues/' + this.get("leagueId") + '/league-instances/';
		},
		
		getTeamList: function() {
			var sortedTeams = this.get("fantasyTeams").sortBy(function(fantasyTeam){ return fantasyTeam.get("draftPosition"); });			
			
			return sortedTeams;
		},
		
		getTeam: function(teamId) {
			return this.get("fantasyTeams").get(teamId);
		},
		
		getTeamByDraftPosition: function(draftPos) {
			this.draftPos = draftPos;
			this.team = null;
			
			this.get("fantasyTeams").each(function(team){
				if(team.get("draftPosition") == this.draftPos){
					this.team = team;
				}
			}, this);
			
			var team = this.team;
			delete this.draftPos;
			delete this.team;
			
			return team;
		},
		
		getTeamOwner: function(teamId) {
			var team = this.getTeam(teamId);
			return this.get("leagueUsers").get(team.get('leagueUserId')).get('userName');
		},
		
		getUserTeams: function(userName) {
			var lgUser = this.getLeagueUser(userName);
			if(!lgUser){
				return null;
			}
			
			this.lgUserId = lgUser.get('id');
			
			var foundTeams = this.get("fantasyTeams").filter(function(team){
				return team.get("leagueUserId") === this.lgUserId;
			}, this);
			
			if(foundTeams){
				var tempTeams = _.sortBy(foundTeams, function(fantasyTeam){ return fantasyTeam.get("draftPosition"); }, this)
				foundTeams = tempTeams;
			}
			
			delete this.lgUserId;
			
			return foundTeams;
		},
		
		getLeagueUser: function(userName) {
			this.user = null;
			this.userName = userName;
			
			this.get("leagueUsers").each(function(leagueUser){
				if(leagueUser.get("userName").toUpperCase() == this.userName.toUpperCase()){
					this.user = leagueUser;
				}
			}, this);
			
			var user = this.user;
			delete this.userName;
			delete this.user;
			
			return user;
		},
		
		numTeams: function() {
			return this.get("fantasyTeams").size();
		},
		
		totalNumPicks: function(pickCollection) {
			var isCustom = this.get('draftType') == 'CUSTOM' ? true : false;
			
			if(isCustom){
				return pickCollection.length;
			} else {
				return this.get('numRounds') * this.numTeams();
			}
		},
		
		isCommissioner: function(userName) {		
			var user = this.getLeagueUser(userName);
			if(user && (user.get("leagueUserRole") == "COMMISH" || user.get("leagueUserRole") == "COCOMMISH")){
				return true;
			} else {
				return false;
			}
		},
		
		isAssistant: function(userName) {		
			var user = this.getLeagueUser(userName);
			if(user && (user.get("leagueUserRole") == "COMMISH" || user.get("leagueUserRole") == "COCOMMISH" || user.get("leagueUserRole") == "ASSISTANT")){
				return true;
			} else {
				return false;
			}
		},
		
		getCommissionerUsers: function() {
			var foundUsers = this.get("leagueUsers").filter(function(user) {
				return user.get("leagueUserRole") == "COMMISH" || user.get("leagueUserRole") == "COCOMMISH";
			}, this);
		
			return _.sortBy(foundUsers, function(user){ return user.prettyDispName(); }, this);
		},
		
		getAssistantUsers: function() {
			var foundUsers = this.get("leagueUsers").filter(function(user) {
				return user.get("leagueUserRole") == "ASSISTANT";
			}, this);
		
			return _.sortBy(foundUsers, function(user){ return user.prettyDispName(); }, this);
		},
		
		getManagerUsers: function() {
			var foundUsers = this.get("leagueUsers").filter(function(user) {
				return user.get("leagueUserRole") == "STANDARD";
			}, this);
		
			return _.sortBy(foundUsers, function(user){ return user.prettyDispName(); }, this);
		},
		
		getCommisssionerUser: function() {
			this.user = null;
			
			this.get("leagueUsers").each(function(leagueUser){
				if(leagueUser.get("leagueUserRole") == "COMMISH"){
					this.user = leagueUser;
				}
			}, this);
			
			var user = this.user;
			delete this.user;
			
			return user;
		},
		
		allowedPositions: function() {
	    	if(this.allowedPositionsArr){
	    		return this.allowedPositionsArr;
	    	}
	    	
	    	var allowedPositions = [];
	    	
	    	this.get('leaguePositions').each(function(lgPos) {
	    		var tmp = _.union(allowedPositions, lgPos.get('positions'));
	    		allowedPositions = tmp;
	    	}, this);
	    	
	    	this.allowedPositionsArr = allowedPositions;
	    	return this.allowedPositionsArr; 
	    },

		initialize: function() {
			
	    },
	    
	    prettyStatus: function() {
	    	if(this.get('draftStatus') == 'SETUP'){
				return "Setup";
			} else if(this.get('draftStatus') == 'PREDRAFT'){
				return "Keeper Mode";
			} else if(this.get('draftStatus') == 'STARTED'){
				return "Started";
			} else if(this.get('draftStatus') == 'COMPLETED'){
				return "Completed";
			} else {
				return null;
			}
	    },
	    
	    prettyDraftType: function() {
	    	if(this.get('draftType') == 'SNAKE'){
				return "Snake";
			} else if(this.get('draftType') == 'STANDARD'){
				return "Standard";
			} else if(this.get('draftType') == 'CUSTOM'){
				return "Custom Order";
			} else if(this.get('draftType') == 'AUCTION'){
				return "Auction";
			} else {
				return null;
			}
	    },
	    
	    prettyDispName: function() {
	    	var dispName = this.get("leagueName").toLowerCase();
			if(this.get("displayName")){
				dispName = this.get("displayName");
			}
			
			return dispName;
	    }
	});
	
	return LeagueInstance;  
});
